const CHOICESLABEL: {[id:number]: string[]} = {
    2: ["ア","イ","ウ","エ","オ","カ","キ","ク","ケ","コ","サ","シ","ス","セ","ソ"],
    3: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O"],
    4: ["Ⓐ","Ⓑ","Ⓒ","Ⓓ","Ⓔ","Ⓕ","Ⓖ","Ⓗ","Ⓘ","Ⓙ","Ⓚ","Ⓛ","Ⓜ","Ⓝ","Ⓞ"],
    5: ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15"]
}

export {CHOICESLABEL}